export const GET_CONTACTS_REQUEST = 'GET_CONTACTS_REQUEST';
export const GET_CONTACTS_FAILURE = 'GET_CONTACTS_FAILURE';
export const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/contacts/mutation-types.js